import { useMemo } from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { CheckInPolicy } from "@b2bportal/lodging-api";
import { useCheckInPolicies } from "@tenant/hotels";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CheckInPoliciesSection.module.scss";

export interface CheckInPoliciesSectionComponentProps
  extends PlatformComponentProps {
  checkInPolicies?: CheckInPolicy[];
}

const COMPONENT_KEY = CoreHotelsComponent.CheckInPoliciesSection;

export const CheckInPoliciesSection = (
  props: CheckInPoliciesSectionComponentProps
) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { context, handlers, text } = useCheckInPolicies(props);

  const content = useMemo(
    () => (
      <ul className={cn("policy-list")}>
        {context.checkInPolicies?.map(({ title, text }) => {
          //TODO: remove when we have validated BE will never send empty string.
          if (text === "") {
            return null;
          }

          return (
            <li className={cn("policy")} key={title}>
              <h3 className={cn("policy-title")}>{title}</h3>
              <ul className={cn("policy-content")}>
                {handlers.cleanPolicy(text).map((item, index) => {
                  return (
                    <li key={index} className={cn("policy-item")}>
                      {item}
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    ),
    [context.checkInPolicies, cn, handlers]
  );

  if (
    context.checkInPolicies == null ||
    context.checkInPolicies?.length === 0
  ) {
    return null;
  }

  return (
    <div className={clsx(className, block)}>
      <h2 className={cn("title")}>{text.title}</h2>
      <div className={cn("content")}> {content} </div>

      <Dialog>
        <DialogTrigger className={cn("read-more")}>
          {text.readMore}
        </DialogTrigger>
        <DialogContent title={text.title}>
          <div className={cn("dialog-content")}>{content}</div>
        </DialogContent>
      </Dialog>

      {children}
    </div>
  );
};
